<template>
  <div class="app">
      <div class="top-banner"><img src="//s1.hdslb.com/bfs/static/jinkela/passport/static/img/rl_top.35edfde.png"></div>
      <Result v-if="resultSearchParams" :params="resultSearchParams" />
      <Form v-else />
  </div>
</template>
<script>
import Form from './pages/Form.vue'
import Result from './pages/Result.vue'
export default {
    name: 'CmmntyAppeal',
    components: {
        Form,
        Result,
    },
    data() {
        return {
            resultSearchParams: null,
        }
    },
    created() {
        const urlObj = new URL(location.href)
        const searchParams = new URLSearchParams(urlObj.search)
        const replyId = searchParams.get('rp_id')
        const reportReason = searchParams.get('report_reason')
        const auditResult = searchParams.get('audit_result')
        const roleType = Number(searchParams.get('role_type') || '2')
        if (replyId && reportReason && auditResult) {
          this.resultSearchParams = {
            replyId,
            reportReason,
            auditResult,
            roleType,
          }
        }
    },
    methods: {
    },
};
</script>

<style>
article, aside, blockquote, body, button, code, dd, details, div, dl, dt, fieldset, figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, header, hgroup, hr, input, legend, li, menu, nav, ol, p, pre, section, td, textarea, th, ul {
    margin: 0;
    padding: 0;
}
body {
  margin: 0;
  font-family: PingFang SC, HarmonyOS_Regular, Helvetica Neue, Microsoft YaHei, sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
}

.top-banner {
  background: #00a0d8;
  height: 86px;
  text-align: center;
  margin-bottom: 20px;
}
</style>
